<template>
  <div>
    <!-- WEB HEADER -->
    <div class="row mb-2" v-show="!isMobile">
      <div class="col-sm-4">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Search Incident"
            />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-8">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showRaiseNewIncident"
            class="btn btn-success btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i> Raise New Incident
          </button>
        </div>
      </div> -->
    </div>

    <!-- MOBILE HEADER -->
    <div class="row mb-2" v-show="isMobile">
      <div class="col-12">
        <div class="search-box me-2 mb-2 d-inline-block w-100">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Search Incident"
            />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <!-- <div class="col-12">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showRaiseNewIncident"
            class="btn btn-primary btn-rounded mb-2 me-2 btn-block w-100"
          >
            <i class="mdi mdi-plus me-1"></i> Raise New Incident
          </button>
        </div>
      </div> -->
    </div>

    <!-- Table -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="allIncidents"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            class="m-1"
            @click="showIncidentDetails(row.item)"
          >
            More Details
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1"
            @click="showReportModal(row.item)"
          >
            Report
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-12">
        <div
          class="
            dataTables_paginate
            paging_simple_numbers
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              class="m-3"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- raise new incident modal -->
    <!-- <b-modal
      id="raise-new-incident-modal"
      title="Raise Challan"
      title-class="font-18"
      size="lg"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Raise New Incident</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('raise-new-incident-modal')"
          >
            <i class="mdi mdi-close"></i> Close
          </button>
        </div>
      </template>
      <RaiseNewIncident />
    </b-modal> -->

    <!-- Report incident modal -->
    <b-modal
      id="report-incident-modal"
      title="Report Incident"
      title-class="font-18"
      size="lg"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <form @submit.prevent="reportIncident">
        <div>
          <div class="mb-3">
            <label>Vehicle Number</label>
            <input
              name="vehicleNumber"
              placeholder="Vehicle Plate Number"
              type="text"
              class="form-control"
              v-model="vehicleNumber"
              maxlength="10"
              style="text-transform: uppercase"
              required
            />
          </div>
          <div class="mb-3">
            <label>Driver Name</label>
            <input
              name="driverName"
              placeholder="Driver Name"
              type="text"
              class="form-control"
              v-model="driverName"
              required
            />
          </div>
          <div class="mb-3">
            <label>No. of Injured People</label>
            <input
              placeholder="No. of Injured People"
              type="number"
              class="form-control"
              v-model="injuredCount"
              required
            />
          </div>

          <div class="mb-3">
            <label>Incident Images</label>
            <file-pond
              ref="pond"
              label-idle="Attach Incident Images"
              :allow-multiple="true"
              accepted-file-types="image/jpeg, image/png"
              max-files="6"
              :files="myFiles"
              :credits="credits"
              imagePreviewMaxHeight="70"
            />
          </div>
        </div>

        <hr />
        <div class="mt-2 text-center">
          <button
            type="submit"
            class="btn btn-danger me-1 w-50"
            @click="reportIncident"
          >
            Report Incident <i class="bx bx-rocket ml-2"></i>
          </button>
        </div>
      </form>
    </b-modal>

    <!-- More details modal -->
    <b-modal
      id="more-details-modal"
      size="xl"
      title-class="font-18"
      hide-footer
    >
      <template #modal-header>
        <div><h5>Incident Details</h5></div>
        <div>
          <button class="btn btn-sm btn-outline-primary m-2" disabled>
            Status: {{ selectedIncident.status }}
          </button>
          <button
            class="btn btn-sm btn-outline-success m-2"
            @click="showResolveConfirmation()"
            v-show="selectedIncident.status === 'Open'"
          >
            <i class="mdi mdi-check"></i> Mark as Resolved
          </button>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('more-details-modal')"
          >
            <i class="mdi mdi-close"></i> Close
          </button>
        </div>
      </template>

      <div class="row">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Incident Id</th>
                      <td>{{ selectedIncident.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Number</th>
                      <td>{{ selectedIncident.vehicle_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Category</th>
                      <td>{{ selectedIncident.category_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sub Category</th>
                      <td>{{ selectedIncident.sub_category_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Source</th>
                      <td>{{ selectedIncident.source_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>{{ selectedIncident.description }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Chainage Number</th>
                      <td>{{ selectedIncident.ch_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Side</th>
                      <td>{{ selectedIncident.side_name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Incident Date/Time</th>
                      <td>
                        {{
                          getReadableDateTime(
                            selectedIncident.incident_datetime
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Reported Date/Time</th>
                      <td>
                        {{
                          new Date(
                            selectedIncident.reported_datetime
                          ).toLocaleString()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Informed To</th>
                      <td>{{ selectedIncident.reported_to_name }}</td>
                    </tr>

                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">Driver Name</th>
                      <td>{{ selectedIncident.driver_name }}</td>
                    </tr>
                    <tr v-show="selectedIncident.category_name === 'Accident'">
                      <th scope="row">No. of Injured People</th>
                      <td>{{ selectedIncident.injured_count }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Response Date/Time</th>
                      <td>{{ selectedIncident.response_datetime }}</td>
                    </tr>
                    <tr>
                      <th scope="row">RPO Comment</th>
                      <td>{{ selectedIncident.comment }}</td>
                    </tr>
                    <tr v-show="selectedIncident.status !== 'Open'">
                      <th scope="row">Close Date/Time</th>
                      <td>{{ selectedIncident.close_datetime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Incident Photos</h4>
              <img
                v-for="(src, index) in incidentImages"
                :key="index"
                class="float-left image"
                @click="() => showCaptiomImg(index)"
                :src="src"
              />
            </div>
            <vue-easy-lightbox
              :visible="visibleCaption"
              :imgs="incidentImages"
              :index="index"
              @hide="handleCaptionHide"
            ></vue-easy-lightbox>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Resolve modal -->
    <b-modal
      id="mark-resolve-modal"
      title="Resolve Confirmation"
      title-class="font-18"
      hide-footer
    >
      <div class="card">
        <div class="card-body p-2">
          <form @submit.prevent="markAsResolved">
            <div class="row">
              <div class="col-12">
                <h4>Incident ID: #{{ selectedIncident.id }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Are you sure you want to mark the incident as resolved?</h6>
                <div class="form-group text-left">
                  <label>Comment*</label>
                  <textarea
                    v-model="resolveComment"
                    class="form-control"
                    placeholder="Enter a closing comment for resolving the incident"
                    required
                  ></textarea>
                </div>
                <hr />

                <h6>Important Notes</h6>
                <ul>
                  <li>
                    <small
                      >You cannot reopen the resolved incident again.</small
                    >
                  </li>
                  <li>
                    <small
                      >Associated RPO will be notified once the incident is
                      marked as resolved.</small
                    >
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" class="btn btn-success btn-block">
                  <i class="fas fa-check"></i> Confirm & Resolve Incident
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Loader from "@/components/widgets/loader";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import incidentMixin from "@/mixins/incident";
import utilsMixin from "@/mixins/utils";

export default {
  mixins: [incidentMixin, utilsMixin],

  components: {
    VueEasyLightbox,
  },

  data() {
    return {
      allIncidents: [],
      visibleCaption: false,
      selectedIncident: {},
      vehicleNumber: null,
      driverName: null,
      injuredCount: null,
      myFiles: [],
      credits: "",
      resolveComment: "",
      index: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "category_name",
          label: "Category",
          sortable: true,
        },
        {
          key: "ch_no",
          label: "Chainage No.",
          sortable: false,
        },
        {
          key: "reported_by_name",
          label: "Reported By",
          sortable: true,
        },
        {
          key: "reported_to_name",
          label: "Reported To",
          sortable: true,
        },
        {
          key: "incident_datetime",
          label: "Date | Time",
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],
    };
  },
  methods: {
    gotoRaiseNewIncidentPage() {
      this.$router.push("/incident/raise-incident");
    },

    showRaiseNewIncident() {
      this.$bvModal.show("raise-new-incident-modal");
    },

    getUserId() {
      const userData = this.$store.getters["auth/user"];
      return userData.user.id;
    },

    async getIncidentDetails() {
      this.allIncidents = [];
      const userId = this.getUserId();
      const incidents = await this.GetRpoIncidens(userId);
      for (let incident of incidents) {
        this.allIncidents.push({
          ...incident,

          _cellVariants:
            incident.status === "Open"
              ? { status: "danger" }
              : { status: "success" },
        });
      }

      this.totalRows = this.allIncidents.length;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getReadableDateTime(dateTime) {
      if (dateTime) {
        const date = String(dateTime).split("T");
        return `${date[0].toUpperCase()}, ${date[1].toUpperCase()}`;
      }
    },

    showIncidentDetails(incident) {
      this.selectedIncident = incident;
      this.$bvModal.show("more-details-modal");
    },

    showReportModal(incident) {
      this.selectedIncident = incident;
      this.$bvModal.show("report-incident-modal");
      this.vehicleNumber = this.selectedIncident.vehicle_no;
      this.driverName = this.selectedIncident.driver_name;
      this.injuredCount = this.selectedIncident.injured_count;
    },

    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    showResolveConfirmation() {
      this.$bvModal.show("mark-resolve-modal");
    },

    async markAsResolved() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);

        const body = {
          id: this.selectedIncident.id,
          comment: this.resolveComment,
        };

        await this.ResolveIncident(body);
        await this.getIncidentDetails();

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Incident Resolved",
          "Incident has been resolved and notifications have been sent out to respective teams",
          "success"
        ).then(() => {
          this.$bvModal.hide("mark-resolve-modal");
          this.$bvModal.hide("more-details-modal");
        });
      } catch (e) {
        Swal.fire(
          "Operation Failed",
          "Failed to resolve the incident due to some technical issue.",
          "error"
        ).then(() => {
          this.$bvModal.hide("more-details-modal");
        });
      }
    },

    reportGenerated() {
      Swal.fire(
        "Report Generated",
        "Report has been generated to this incident",
        "success"
      ).then(() => {
        this.$bvModal.hide("report-incident-modal");
      });
    },

    async reportIncident() {
      await this.reportGenerated();
      const body = {
        id: this.selectedIncident.id,
        vehicle_no: this.vehicleNumber,
        driver_name: this.driverName,
        injured_count: this.injuredCount,
      };
      await this.ReportIncident(body);
    },

    //Get violation data from VEHANT API
    async getViolationData() {
      await this.GetViolationsData();
    },
  },

  computed: {
    isMobile() {
      return this.IsMobileDevice();
    },
    rows() {
      return this.allIncidents.length;
    },
    incidentImages() {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },

    incidents() {
      return this.$store.getters["incident/incidents"];
    },
  },

  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.getIncidentDetails();
    this.$store.dispatch("layout/changeLoaderValue", false);
    await this.getUserId();
    this.getViolationData();
  },
};
</script>
<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
